import {
  GET_INTERNSHIPS,
  GET_INTERNSHIPS_SUCCESS,
  GET_INTERNSHIPS_FAILURE,
  GET_JOB_COMPANIES,
  GET_JOB_COMPANIES_SUCCESS,
  GET_JOB_COMPANIES_FAILURE,
  GET_JOB_TYPES,
  GET_JOB_TYPES_SUCCESS,
  GET_JOB_TYPES_FAILURE,
} from "../constants";

export default class InternshipsAction {
  static getInternships(payload, cb) {
    return {
      type: GET_INTERNSHIPS,
      payload,
      cb,
    };
  }
  static getInternshipsSuccess(payload) {
    return {
      type: GET_INTERNSHIPS_SUCCESS,
      payload,
    };
  }
  static getInternshipsFailure(payload) {
    return {
      type: GET_INTERNSHIPS_FAILURE,
      payload,
    };
  }
  static getJobCompanies(cb) {
    return {
      type: GET_JOB_COMPANIES,
      cb,
    };
  }
  static getJobCompaniesSuccess(payload) {
    return {
      type: GET_JOB_COMPANIES_SUCCESS,
      payload,
    };
  }
  static getJobCompaniesFailure(payload) {
    return {
      type: GET_JOB_COMPANIES_FAILURE,
      payload,
    };
  }
  static getJobTypes(cb) {
    return {
      type: GET_JOB_TYPES,
      cb,
    };
  }
  static getJobTypesSuccess(payload) {
    return {
      type: GET_JOB_TYPES_SUCCESS,
      payload,
    };
  }
  static getJobTypesFailure(payload) {
    return {
      type: GET_JOB_TYPES_FAILURE,
      payload,
    };
  }
}
